module.exports = __webpack_public_path__ + "img/gm.62b77c6e.svg";